// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canSetIntegration } from "./check";

export function useCanSetIntegration(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canSetIntegration(withinScope);
  return canDoAction;
}
